import TimeAndAgo from '@/components/TimeAndAgo.vue';
import PzButton from '@/components/PzButton.vue';
import CommentEdit from '@/views/QA/Question/components/Comment/CommentEdit.vue';
import Comment from '@/views/QA/Question/components/Comment/Comment.vue';
import Thumb from '@/views/QA/Question/components/Thumb.vue';
import BigQ from '@/views/QA/Question/components/BigQ.vue';

import { FixBlankAvatarMixin } from '@/scripts/QA/mixins/FixBlankAvatarMixin';
import { QaQuestionContentMixin } from '@/scripts/QA/Question/mixins/QaQuestionContentMixin';
import { QaQuestionUpdateMixin } from '@/scripts/QA/Question/mixins/QaQuestionUpdateMixin';
import { QaQuestionCommentMixin } from '@/scripts/QA/Question/mixins/QaQuestionCommentMixin';

export default {
  name: 'QaQuestionContentQuestion',

  mixins: [
    //
    FixBlankAvatarMixin,
    QaQuestionContentMixin,
    QaQuestionUpdateMixin,
    QaQuestionCommentMixin,
  ],

  components: {
    'time-and-ago': TimeAndAgo,
    PzButton,
    CommentEdit,
    Comment,
    Thumb,
    BigQ,
  },

  props: {
    p_objQa: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    ///
    c_objQaContent() {
      return this.p_objQa.qaContent;
    },
  },
};
